import { FormControlLabel, FormGroup, styled, Switch } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import * as React from "react";
import { useEffect } from "react";

const IOSSwitch = styled(props => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 28,
  height: 18,
  padding: 0,

  "& .MuiIconButton-root": {
    padding: 0,
    margin: "2px 0 2px 2px",
    transitionDuration: "300ms",
    boxShadow: "0px 4px 8px rgba(195, 196, 197, 0.4)",
    top: "2px",
    left: "0",
    "&.Mui-checked": {
      transform: "none",
      left: "6px",
      color: "#fff",
      "& + .MuiSwitch-track": {
        border: `1.5px solid ${theme.palette.info.dark}`,
        background: "#009FB8",
        opacity: 1
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        background: "#A7A8A9"
      }
    },

    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff"
    },

    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100]
    },

    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7
    },

    "& .MuiSwitch-input": {
      width: "100%"
    }
  },

  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 10,
    height: 10,
    color: "white",
    boxShadow: "none"
  },

  "& .MuiSwitch-track": {
    width: 28,
    height: 18,
    borderRadius: 9,
    backgroundColor: theme.palette.grey[300],
    border: `1.5px solid ${theme.palette.grey[400]}`,
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500
    })
  }
}));
interface IUISwitch {
  onChange: (event) => void;
  name: string;
  label?: string;
  defaultChecked?: boolean;
  disabled?: boolean;
  id?: string;
}
const useStyles = makeStyles(
  theme => ({
    active: {
      "& .MuiTypography-root": {
        fontSize: "12px",
        lineHeight: "18px",
        marginLeft: "6px",
        color: theme.palette.info.dark
      }
    },
    inactive: {
      "& .MuiTypography-root": {
        fontSize: "12px",
        lineHeight: "18px",
        marginLeft: "6px",
        color: theme.palette.grey[700]
      }
    }
  }),
  { name: "IUISwitch" }
);
const UISwitch: React.FC<IUISwitch> = ({
  onChange,
  name,
  defaultChecked,
  disabled,
  id
}) => {
  const [checked, setChecked] = React.useState(defaultChecked);
  const classes = useStyles();
  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  const handleChange = event => {
    setChecked(event.target.checked);
    onChange({
      target: {
        name,
        value: !!event.target.checked
      }
    });
  };

  return (
    <FormGroup>
      <FormControlLabel
        label={checked ? "Active" : "Inactive"}
        control={
          <IOSSwitch
            sx={{ m: 1 }}
            checked={checked}
            onChange={handleChange}
            name={name}
            disabled={disabled}
            id={id}
          />
        }
        className={checked ? classes.active : classes.inactive}
      />
    </FormGroup>
  );
};

export default UISwitch;
